export default {
  Desktop: defineAsyncComponent(() => import('./MenuDesktop.vue')),
  DesktopDropdown: defineAsyncComponent(() => import('./MenuDesktopDropdown.vue')),
  DesktopItem: defineAsyncComponent(() => import('./MenuDesktopItem.vue')),
  Item: defineAsyncComponent(() => import('./MenuItem.vue')),
  ItemTitle: defineAsyncComponent(() => import('./MenuItemTitle.vue')),
  Mobile: defineAsyncComponent(() => import('./MenuMobile.vue')),
};
